import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
/* import { ChartsModule } from '@progress/kendo-angular-charts';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout'; */
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ApiService } from 'src/api.service';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DeleteComponent } from './delete/delete.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { LettersTableComponent } from './letters-table/letters-table.component';
import { PdfDialogComponent } from './pdf-dialog/pdf-dialog.component';
import { SanitizeHtmlPipe } from './shared/pipe/sanitize-html.pipe';
import { BatchInfoComponent } from './batch-info/batch-info.component';
import { SharedModule } from './shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { StatsModule } from './modules/stats/stats.module';
import { AccessHistoryModule } from './modules/access-history/access-history.module';
import { CoreModule } from './core/core.module';
import { DeleteBatchComponent } from './delete-batch/delete-batch.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
// import { CustomersComponent } from './shared/customers/customers.component';


const impCallback = 'login/callback';
let okta_redirectUri = `${location.origin}/${impCallback}`;

const oktaAuth = new OktaAuth({
  issuer: environment.okta_issuer,
  clientId: environment.okta_client_id,
  // redirectUri: environment.okta_redirect_uri
  redirectUri: okta_redirectUri,
  // Access tokens live ~1 hour. These are the SDK defaults, set explicitly because
  // the API now rejects expired tokens and we rely on renewal happening without an
  // interactive redirect. OktaAuthModule calls oktaAuth.start(), which runs these
  // background services.
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    // Tokens are kept in localStorage (the SDK default). Do not switch this to
    // sessionStorage: LogoutComponent clears tokens via localStorage.clear(), and
    // syncStorage keeps sign in/out consistent across tabs.
    syncStorage: true
  },
  services: {
    autoRenew: true,
    syncStorage: true,
    renewOnTabActivation: true
  }
});


@NgModule({
  declarations: [
    AppComponent,
    LettersTableComponent,
    DocumentDetailsComponent,
    PdfDialogComponent,
    DeleteComponent,
    SanitizeHtmlPipe,
    BatchInfoComponent,
    DeleteBatchComponent,
    // CustomersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    MatTableModule,
    MatPaginatorModule,
   /*  LayoutModule,
    GridModule,
    ChartsModule, */
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatTooltipModule,
    OktaAuthModule,
    CoreModule,
    SharedModule,
    MatCheckboxModule,
    StatsModule,
    AccessHistoryModule,
    MatSnackBarModule
  ],
  exports: [
    SanitizeHtmlPipe
  ],
  providers: [
    provideZoneChangeDetection(),
    DatePipe,
    ApiService,
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      // ModalHistoryService closes dialogs on browser back one at a time; Material's own
      // handling would close every open dialog at once.
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { ...new MatDialogConfig(), closeOnNavigation: false }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }